import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPenSolid = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.91142 2.74805L0.671841 9.98763L0.333299 12.9564C0.307257 13.1647 0.359341 13.347 0.515591 13.4772C0.645799 13.6335 0.828091 13.6855 1.03642 13.6595L4.00517 13.321L11.2448 6.08138L7.91142 2.74805ZM13.302 2.25326C13.5364 2.51367 13.6666 2.80013 13.6666 3.13867C13.6666 3.50326 13.5364 3.78971 13.302 4.02409L11.8177 5.50846L8.48434 2.17513L9.96872 0.690755C10.2031 0.45638 10.4895 0.326172 10.8541 0.326172C11.1927 0.326172 11.4791 0.45638 11.7395 0.690755L13.302 2.25326Z",
		fill: "currentColor"
	})
});
export default SvgPenSolid;
